import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Checkbox, FormField, Select } from "ui";

import { EveryTypeOptions } from "../NotificationForm.constants";
import { NotificationFormValues } from "../NotificationForm.types";

import styles from "../NotificationForm.module.scss";

export const RepeatsFields = () => {
  const { t } = useTranslation();
  const { control, watch } = useFormContext<NotificationFormValues>();

  const neverRepeatWatch = watch("repetition.neverRepeat");

  return (
    <div className={styles.form_separatedBlock}>
      <FormField label={t("Repeats")} labelClassName={styles.form_fieldLabel}>
        <div className={styles.form_twoColumnsBlock}>
          <Controller
            control={control}
            name={"repetition.every"}
            render={({ field: { value, onChange } }) => (
              <Select
                value={String(value)}
                options={Array.from({ length: 30 }, (_, i) => ({
                  label: `${t("Every")} ${i + 1}`,
                  value: `${i + 1}`
                }))}
                onChange={(nextValue) => onChange(Number(nextValue))}
                placeholder={t("Select Repetition Type")}
                disabled={neverRepeatWatch}
              />
            )}
          />

          <Controller
            control={control}
            name={"repetition.type"}
            render={({ field: { value, onChange } }) => (
              <Select
                value={value}
                options={EveryTypeOptions}
                onChange={onChange}
                placeholder={t("Select Repetition Type")}
                disabled={neverRepeatWatch}
              />
            )}
          />
        </div>

        <Controller
          control={control}
          name="repetition.neverRepeat"
          render={({ field: { value, onChange } }) => (
            <Checkbox
              checked={value}
              label={t("Never Repeat")}
              onChange={onChange}
              className={styles.form_checkbox}
            />
          )}
        />
      </FormField>
    </div>
  );
};
